/* ---------------------------------------------------------------------------------------------------------------
   MJP - AVVISI E PROMOZIONI (sections/mjp-notices.liquid)
   ---------------------------------------------------------------------------------------------------------------
   Regia unica dei popup promozionali. Nasce dal JavaScript della campagna "Spedizione gratuita weekend" (settembre
   2026), esteso da un avviso a tanti:

   1. Date. Liquid stampa l'avviso con 15 minuti di margine, perche' l'HTML di Shopify puo' arrivare dalla cache.
      Qui, in tempo reale, si decide se e' davvero attivo. Start 0 = attivo da subito, end 0 = senza scadenza.
   2. Un avviso per pagina. Si candida il primo della lista attivo e non ancora visto; gli altri aspettano le pagine
      successive, quando il primo risultera' gia' visto.
   3. Mai sopra un'altra finestra. Se al momento di aprirsi c'e' gia' qualcosa aperto (cofanetto, avviso cofanetti,
      cura del piercing, newsletter, carrello), riprova poco dopo invece di sovrapporsi.
   4. Countdown. Un solo ticker per pagina.

   Espone window.MJPNotices.isOpen(): gli altri avvisi del tema lo usano per non aprirsi sopra un popup promozionale.
   --------------------------------------------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.MJPNotices && window.MJPNotices.ready) return;

  var SELECTOR = '[data-mjp-notice]';
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var RETRY_MS = 1500;

  /* Le altre finestre del tema e delle app: se una e' aperta, l'avviso aspetta. */
  var BUSY_SELECTOR = [
    '[data-mgbx-dlg]:not([hidden])',
    '[data-gbn]:not([hidden])',
    '[data-pups]:not([hidden])',
    '.mjp__variant-modal.is-open',
    '.mjp__zoom-modal.is-open',
    'newsletter-popup[open]',
    'cart-drawer[open]',
    'cart-notification-drawer[open]',
    'quick-buy-drawer[open]'
  ].join(',');

  var serverSkewMs = 0;
  var ticker = null;
  var keysBound = false;
  var shownThisPage = false;

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function toMs(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n * 1000;
  }

  function now() {
    return Date.now() + serverSkewMs;
  }

  /* L'ora reale non puo' essere precedente al render del server: si corregge solo in avanti. */
  function calibrate(el) {
    var serverNow = toMs(el.getAttribute('data-server-now'));
    if (!serverNow) return;
    var skew = serverNow - Date.now();
    if (skew > serverSkewMs) serverSkewMs = skew;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function all() {
    return document.querySelectorAll(SELECTOR);
  }

  function isOpen() {
    return !!document.querySelector('.mjp-ntc.is-open');
  }

  function isBusy() {
    return !!document.querySelector(BUSY_SELECTOR);
  }

  function remove(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Date
     --------------------------------------------------------------------------------------------------------------- */

  function isLive(el) {
    if (isDesignMode() && el.getAttribute('data-preview') === '1') return true;

    var start = toMs(el.getAttribute('data-start'));
    var end = toMs(el.getAttribute('data-end'));
    var t = now();

    if (start && t < start) return false;
    if (end && t >= end) return false;
    return true;
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Frequenza
     --------------------------------------------------------------------------------------------------------------- */

  function storageKey(el) {
    return el.getAttribute('data-storage-key') || 'mjp_ntc';
  }

  function alreadySeen(el) {
    if (isDesignMode()) return false;

    var mode = el.getAttribute('data-frequency') || 'session';
    if (mode === 'always') return false;

    try {
      if (mode === 'session') return sessionStorage.getItem(storageKey(el)) === '1';
      return localStorage.getItem(storageKey(el)) === new Date().toDateString();
    } catch (e) {
      /* Storage negato (navigazione privata): meglio mostrarlo una volta in piu' che mai. */
      return false;
    }
  }

  function markSeen(el) {
    if (isDesignMode()) return;

    var mode = el.getAttribute('data-frequency') || 'session';
    if (mode === 'always') return;

    try {
      if (mode === 'session') sessionStorage.setItem(storageKey(el), '1');
      else localStorage.setItem(storageKey(el), new Date().toDateString());
    } catch (e) {}
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Apertura e chiusura
     --------------------------------------------------------------------------------------------------------------- */

  function open(el) {
    if (el.classList.contains('is-open')) return;

    el.__mjpReturnFocus = document.activeElement;
    el.hidden = false;

    /* Due frame: il primo toglie display:none, il secondo fa partire la transizione. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        el.classList.add('is-open');
        var focusTarget = el.querySelector('[data-mjp-notice-close]') || el.querySelector(FOCUSABLE);
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    });

    tick();
    startTicker();
  }

  function close(el) {
    if (!el.classList.contains('is-open')) return;

    el.classList.remove('is-open');
    markSeen(el);

    var returnFocus = el.__mjpReturnFocus;
    if (returnFocus && typeof returnFocus.focus === 'function' && document.body.contains(returnFocus)) {
      returnFocus.focus({ preventScroll: true });
    }

    window.setTimeout(function () {
      if (el.classList.contains('is-open')) return;
      el.hidden = true;
      if (!isDesignMode()) remove(el);
    }, 500);
  }

  function bindKeys() {
    if (keysBound) return;
    keysBound = true;

    document.addEventListener('keydown', function (event) {
      var opened = document.querySelectorAll('.mjp-ntc.is-open');
      if (!opened.length) return;

      var el = opened[opened.length - 1];

      if (event.key === 'Escape') {
        close(el);
        return;
      }

      if (event.key !== 'Tab') return;

      /* Dialog modale: il Tab resta dentro. */
      var focusables = [];
      var candidates = el.querySelectorAll(FOCUSABLE);
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetParent !== null || candidates[i] === document.activeElement) focusables.push(candidates[i]);
      }
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!el.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function wire(el) {
    var closers = el.querySelectorAll('[data-mjp-notice-close]');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', function () {
        close(el);
      });
    }

    el.addEventListener('click', function (event) {
      if (event.target === el) close(el);
    });

    /* Chi clicca un bottone con link ha gia' ricevuto il messaggio. */
    var links = el.querySelectorAll('a[href]');
    for (var j = 0; j < links.length; j++) {
      links[j].addEventListener('click', function () {
        markSeen(el);
      });
    }
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Countdown
     --------------------------------------------------------------------------------------------------------------- */

  function renderCountdown(box, remainingMs) {
    var total = Math.max(0, Math.floor(remainingMs / 1000));
    var values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60
    };

    var slots = box.querySelectorAll('[data-mjp-notice-cd]');
    for (var i = 0; i < slots.length; i++) {
      var unit = slots[i].getAttribute('data-mjp-notice-cd');
      setText(slots[i], unit === 'days' ? String(values.days) : pad(values[unit]));
    }

    /* Senza giorni rimasti il riquadro dei giorni sparisce: niente "0 giorni". */
    var dayUnit = box.querySelector('[data-mjp-notice-cd-unit="days"]');
    if (dayUnit && dayUnit.hidden !== (values.days === 0)) dayUnit.hidden = values.days === 0;
  }

  function tick() {
    var list = all();
    if (!list.length) {
      if (ticker) {
        clearInterval(ticker);
        ticker = null;
      }
      return;
    }

    for (var i = 0; i < list.length; i++) {
      var el = list[i];

      if (!isLive(el)) {
        /* Scaduto mentre la pagina era aperta: fuori, anche se aperto. Nell'editor resta per poterlo modificare. */
        if (!isDesignMode()) {
          if (el.classList.contains('is-open')) close(el);
          else remove(el);
        }
        continue;
      }

      var box = el.querySelector('[data-mjp-notice-countdown]');
      if (!box) continue;

      var end = toMs(el.getAttribute('data-end'));
      var remaining = end - now();
      if (!end || remaining <= 0) {
        if (!box.hidden) box.hidden = true;
        continue;
      }
      if (box.hidden) box.hidden = false;
      renderCountdown(box, remaining);
    }
  }

  function startTicker() {
    if (!ticker) ticker = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Regia: un avviso per pagina, mai sopra altre finestre
     --------------------------------------------------------------------------------------------------------------- */

  function attemptOpen(el) {
    if (!document.body.contains(el) || shownThisPage) return;

    if (!isLive(el)) {
      remove(el);
      candidate();
      return;
    }

    if (isBusy() || isOpen()) {
      window.setTimeout(function () {
        attemptOpen(el);
      }, RETRY_MS);
      return;
    }

    shownThisPage = true;
    open(el);
  }

  /* Il primo avviso della lista che puo' essere mostrato; quelli gia' visti o scaduti escono di scena. */
  function candidate() {
    if (isDesignMode() || shownThisPage) return;

    var list = all();
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.getAttribute('data-mjp-notice-queued') === '1') return;

      if (!isLive(el) || alreadySeen(el)) {
        remove(el);
        continue;
      }

      el.setAttribute('data-mjp-notice-queued', '1');
      var delay = parseInt(el.getAttribute('data-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 0;

      window.setTimeout(function () {
        attemptOpen(el);
      }, delay * 1000);
      return;
    }
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Avvio
     --------------------------------------------------------------------------------------------------------------- */

  function setup(root) {
    var found = (root || document).querySelectorAll(SELECTOR);

    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      if (el.getAttribute('data-mjp-notice-ready') === '1') continue;
      el.setAttribute('data-mjp-notice-ready', '1');

      calibrate(el);
      el.hidden = true;

      /* Nel body nessun contenitore del header (sticky, transform, overflow) puo' intrappolare il fixed. */
      if (el.parentNode !== document.body) document.body.appendChild(el);

      wire(el);
    }

    bindKeys();
    tick();
    candidate();
  }

  window.MJPNotices = {
    ready: true,
    isOpen: isOpen
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
    });
  } else {
    setup();
  }

  /* Editor del tema: l'avviso si apre selezionando il suo blocco e si chiude deselezionandolo. */
  if (isDesignMode()) {
    var byBlock = function (event) {
      var id = event.detail && event.detail.blockId;
      if (!id) return null;
      return document.querySelector(SELECTOR + '[data-block-id="' + id + '"]');
    };

    var bySection = function (event) {
      var id = event.detail && event.detail.sectionId;
      return id ? document.querySelectorAll(SELECTOR + '[data-section-id="' + id + '"]') : [];
    };

    document.addEventListener('shopify:section:load', function (event) {
      setup(event.target);
    });

    /* Gli avvisi sono stati spostati nel body: quando l'editor ricarica la sezione vanno tolti a mano. */
    document.addEventListener('shopify:section:unload', function (event) {
      var stale = bySection(event);
      for (var i = 0; i < stale.length; i++) remove(stale[i]);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var el = byBlock(event);
      if (!el) return;
      var opened = document.querySelectorAll('.mjp-ntc.is-open');
      for (var i = 0; i < opened.length; i++) {
        if (opened[i] !== el) close(opened[i]);
      }
      open(el);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var el = byBlock(event);
      if (el) close(el);
    });
  }
})();
